import { resolveImage as i, resolveLink as o, resolveIcon as p } from "../../../helpers/index.js";
const s = (e) => ({
  header: e.properties?.header,
  text: e.properties?.text,
  teaser: e.properties?.subject,
  image: e.properties?.image?.[0] && i(e.properties?.image, !1, "portrait"),
  partner: e.properties?.partner,
  links: e.properties?.linkList?.items.map(
    (r) => o({
      ...r.content.properties?.link[0],
      icon: p(r.content.properties?.ikon)
    })
  )
});
export {
  s as ConditionBoxDeliveryApiParser
};
